export const HERE_APP_ID = '0b5Ih9ViXC5kPNCb0VH2';
export const HERE_APP_CODE = 'Nsr2FRMW9Xjvho8gUxePEQ';
